import { useEffect, useState } from 'react'

export function useStickyBar(heroId: string, offerId: string) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById(heroId)
      const offer = document.getElementById(offerId)
      if (!hero || !offer) return
      const pastHero = window.scrollY > hero.offsetHeight * 0.8
      const r = offer.getBoundingClientRect()
      const inOffer = r.top < window.innerHeight && r.bottom > 0
      setVisible(pastHero && !inOffer)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [heroId, offerId])

  return visible
}
